import DataValidation from './DataValidation';

export default DataValidation;